import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function CarruselOneImage({images}) {
  return (
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      slidesPerView={1}
      loop
      pagination={{ clickable: true }}
      navigation
      /* autoplay={{ delay: 4000, disableOnInteraction: false }} */
    >
      {images.map((src, i) => (
        <SwiperSlide key={i}>
          <img
            src={src}
            alt={`slide-${i}`}
            className="w-100 object-fit-cover"
            style={{height: "80vh",borderRadius: "10px"}}
            loading="lazy"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  )
}
